export default __webpack_public_path__ + "static/media/allow-bmg-6.8843fd62.png";